import { render, staticRenderFns } from "./SampleProductDeliveryOption.vue?vue&type=template&id=50867386&scoped=true"
import script from "./SampleProductDeliveryOption.vue?vue&type=script&lang=js"
export * from "./SampleProductDeliveryOption.vue?vue&type=script&lang=js"
import style0 from "./SampleProductDeliveryOption.vue?vue&type=style&index=0&id=50867386&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50867386",
  null
  
)

export default component.exports